export const SET_SANTE_STEP = "SET_SANTE_STEP";
export const SET_SANTE_PHASE = "SET_SANTE_PHASE";
export const SET_SANTE_SUBMISSION_REF = "SET_SANTE_SUBMISSION_REF";
export const SET_SANTE_ACTIVE_AFFILIATION = "SET_SANTE_ACTIVE_AFFILIATION";

// Champs personne (adhérent ou affilié)
export const SET_SANTE_ADHERENT_FIELD = "SET_SANTE_ADHERENT_FIELD";
export const SET_SANTE_AFFILIATION_FIELD = "SET_SANTE_AFFILIATION_FIELD";

// Questionnaire médical
export const TOGGLE_SANTE_AFFLICTION = "TOGGLE_SANTE_AFFLICTION";
export const SET_SANTE_AFFLICTION_AUTRE = "SET_SANTE_AFFLICTION_AUTRE";
export const ADD_SANTE_MEDICATION = "ADD_SANTE_MEDICATION";
export const REMOVE_SANTE_MEDICATION = "REMOVE_SANTE_MEDICATION";

// Affiliés
export const ADD_SANTE_AFFILIATION = "ADD_SANTE_AFFILIATION";
export const REMOVE_SANTE_AFFILIATION = "REMOVE_SANTE_AFFILIATION";

// Déclaration / consentement
export const SET_SANTE_DECLARATION_NAME = "SET_SANTE_DECLARATION_NAME";
export const SET_SANTE_DECLARATION_ACCEPTED = "SET_SANTE_DECLARATION_ACCEPTED";
export const SET_SANTE_CONSENT_DATA = "SET_SANTE_CONSENT_DATA";

// Fichiers
export const SET_SANTE_FILE = "SET_SANTE_FILE";

// Erreurs
export const SET_SANTE_ERRORS = "SET_SANTE_ERRORS";
export const SET_SANTE_ERROR = "SET_SANTE_ERROR";
export const CLEAR_SANTE_ERRORS = "CLEAR_SANTE_ERRORS";

// Loading
export const SET_SANTE_LOADING = "SET_SANTE_LOADING";

// Reset
export const RESET_SANTE = "RESET_SANTE";
